import {
  OuiCenterComponent,
  OuiGridComponent,
  OuiStackComponent,
  OuiTextComponent,
  ThemeService,
} from '@aiz-gl/omni-ui';
import { Component, effect, inject } from '@angular/core';
import { css } from '@emotion/css';
import { Region } from '../../models/region.model';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-regions',
  imports: [
    OuiGridComponent,
    OuiTextComponent,
    OuiStackComponent,
    OuiCenterComponent,
  ],
  templateUrl: './region-select.component.html',
})
export class RegionSelectPage extends BasePageComponent {
  theme = inject(ThemeService);

  constructor() {
    super();
    effect(() => {
      const regions = this.regions.availableRegions(this.auth.authProfile());
      // Automatically select the first region if there is only one region available.
      if (regions().length === 1) this.selectRegion(regions()[0]);
    });
  }

  regionButton = css({
    cursor: 'pointer',
    transition: 'all 350ms ease-in-out',
    '&:hover': {
      ...this.theme.colorPair('tertiary'),
      transform: 'scale(1.05)',
    },
  });

  selectRegion(region: Region) {
    this.regions.selectRegion(region.code);
    this.router.navigate(['/dashboard']);
  }
}
